/* ==========================================================================
   THROTTLE CO — SHIPPING PROTECTION: DEFAULT ON (opt-out)
   Layers on top of the protection toggle + band reconciler in global.js.
   When the cart has qualifying (non-protection) items and the shopper has
   NOT turned protection off, the correct protection band is added
   automatically. Turning the toggle off is remembered so it is not re-added;
   emptying the cart clears that memory so a fresh cart defaults on again.
   ========================================================================== */
(function () {
  'use strict';

  var OPTOUT_KEY = 'tc_protection_optout';
  var working = false;

  function isOptedOut() {
    try { return localStorage.getItem(OPTOUT_KEY) === '1'; } catch (e) { return false; }
  }
  function setOptOut(state) {
    try {
      if (state) localStorage.setItem(OPTOUT_KEY, '1');
      else localStorage.removeItem(OPTOUT_KEY);
    } catch (e) { /* private mode — best effort */ }
  }

  function getConfig() {
    var toggle = document.querySelector('#tc-cart-drawer [data-protection-toggle]');
    if (!toggle) return null;
    try {
      var variants = JSON.parse(toggle.getAttribute('data-protection-variants')) || [];
      if (!variants.length) return null;
      return { variants: variants };
    } catch (e) {
      return null;
    }
  }

  function isProtection(item, config) {
    if (item.properties && item.properties._tc_protection) return true;
    return config.variants.some(function (v) { return v.id === item.variant_id; });
  }

  function pickVariant(basisCents, variants) {
    var match = variants.find(function (v) { return v.max > 0 && basisCents <= v.max; });
    return match || variants[variants.length - 1];
  }

  function basisOf(cart, config) {
    return cart.items.reduce(function (sum, item) {
      if (isProtection(item, config)) return sum;
      return sum + item.final_line_price;
    }, 0);
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function ensureDefault() {
    var config = getConfig();
    if (!config || working) return Promise.resolve();
    working = true;
    return fetchCart().then(function (cart) {
      var hasProtection = cart.items.some(function (item) { return isProtection(item, config); });
      var basis = basisOf(cart, config);

      // Nothing to protect yet: reset opt-out so the next cart defaults on again.
      if (basis <= 0) {
        if (!hasProtection) setOptOut(false);
        return null;
      }
      // Already on, or the shopper turned it off: leave it alone.
      if (hasProtection || isOptedOut()) return null;

      // Default on: add the band that matches the current cart total.
      var variant = pickVariant(basis, config.variants);
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: 1, properties: { _tc_protection: '1' } })
      }).then(function (res) {
        if (res.ok && window.ThrottleCart) return window.ThrottleCart.refresh();
        return null;
      });
    }).catch(function (e) {
      console.warn('[TcProtectionDefault] failed', e);
    }).then(function () {
      working = false;
    });
  }

  // Remember an explicit choice: off => opted out, on => opted back in.
  document.addEventListener('change', function (event) {
    var toggle = event.target.closest('[data-protection-toggle]');
    if (!toggle) return;
    setOptOut(!toggle.checked);
  });

  document.addEventListener('cart:updated', ensureDefault);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureDefault);
  } else {
    ensureDefault();
  }
})();
